import { render, staticRenderFns } from "./ConsumablesProducts.vue?vue&type=template&id=3f38487d&scoped=true"
import script from "./ConsumablesProducts.vue?vue&type=script&lang=js"
export * from "./ConsumablesProducts.vue?vue&type=script&lang=js"
import style0 from "./ConsumablesProducts.vue?vue&type=style&index=0&id=3f38487d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f38487d",
  null
  
)

export default component.exports